// extracted by mini-css-extract-plugin
export default {"loader":"LoadingSpinner_loader__oXViY","mulShdSpin":"LoadingSpinner_mulShdSpin__htSjq"};